import LoadingButton from 'components/LoadingButton/LoadingButton';

export default function BottomSheetPrimaryButton({ children, onClick, loading }) {
  return (
    <LoadingButton
      variant="contained"
      size="large"
      sx={{ mt: 3 }}
      fullWidth
      onClick={onClick}
      loading={loading}
    >
      {children}
    </LoadingButton>
  );
}
